/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_Not_BuiltInputs */

const th_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่วนนี้ยังไม่เปิดใช้งาน`)
};

const en_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This section is not built yet.`)
};

const ja_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この項目はまだ実装されていません。`)
};

const zh_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此部分尚未构建。`)
};

const es_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta sección todavía no está hecha.`)
};

const pt_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta seção ainda não foi feita.`)
};

const id_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagian ini belum dibuat.`)
};

const fr_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette section n’est pas encore réalisée.`)
};

const tl_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi pa nagagawa ang bahaging ito.`)
};

const vi_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phần này chưa được dựng.`)
};

const ko_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 부분은 아직 만들어지지 않았습니다.`)
};

const de_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Bereich ist noch nicht gebaut.`)
};

const ru_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот раздел ещё не сделан.`)
};

const tr_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu bölüm henüz yapılmadı.`)
};

const it_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa parte non è ancora stata realizzata.`)
};

const pl_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta część nie została jeszcze zbudowana.`)
};

const uk_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей розділ ще не зроблено.`)
};

const hi_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह हिस्सा अभी बना नहीं है।`)
};

const ar_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا الجزء لم يُبنَ بعد.`)
};

const ms_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahagian ini belum dibina.`)
};

const bn_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই অংশ এখনও তৈরি হয়নি।`)
};

const zh_tw2_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個部分尚未建置。`)
};

const zh_hk2_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個部分尚未建置。`)
};

const ur_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ حصہ ابھی نہیں بنا۔`)
};

const fa_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این بخش هنوز ساخته نشده.`)
};

const sw_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehemu hii bado haijajengwa.`)
};

const nl_tab_not_built = /** @type {(inputs: Tab_Not_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit deel is nog niet gebouwd.`)
};

/**
* | output |
* | --- |
* | "This section is not built yet." |
*
* @param {Tab_Not_BuiltInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_not_built = /** @type {((inputs?: Tab_Not_BuiltInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_Not_BuiltInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_not_built(inputs)
	if (locale === "ja") return ja_tab_not_built(inputs)
	if (locale === "zh") return zh_tab_not_built(inputs)
	if (locale === "es") return es_tab_not_built(inputs)
	if (locale === "pt") return pt_tab_not_built(inputs)
	if (locale === "id") return id_tab_not_built(inputs)
	if (locale === "fr") return fr_tab_not_built(inputs)
	if (locale === "tl") return tl_tab_not_built(inputs)
	if (locale === "vi") return vi_tab_not_built(inputs)
	if (locale === "ko") return ko_tab_not_built(inputs)
	if (locale === "de") return de_tab_not_built(inputs)
	if (locale === "ru") return ru_tab_not_built(inputs)
	if (locale === "tr") return tr_tab_not_built(inputs)
	if (locale === "it") return it_tab_not_built(inputs)
	if (locale === "pl") return pl_tab_not_built(inputs)
	if (locale === "uk") return uk_tab_not_built(inputs)
	if (locale === "hi") return hi_tab_not_built(inputs)
	if (locale === "ar") return ar_tab_not_built(inputs)
	if (locale === "ms") return ms_tab_not_built(inputs)
	if (locale === "bn") return bn_tab_not_built(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_not_built(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_not_built(inputs)
	if (locale === "ur") return ur_tab_not_built(inputs)
	if (locale === "fa") return fa_tab_not_built(inputs)
	if (locale === "sw") return sw_tab_not_built(inputs)
	if (locale === "nl") return nl_tab_not_built(inputs)
	return en_tab_not_built(inputs)
});